// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2ZknS","container":"styles_container__GlSRK","title":"styles_title__3kZij","wrapper":"styles_wrapper__1eyey","answer":"styles_answer__2Cy4W"};